/* FORGE gift option — <forge-gift> (markup + the attribute-name contract: snippets/forge-gift.liquid).

   Persists two CART ATTRIBUTES through /cart/update.js, debounced like Dawn's <cart-note>:
     Gift         "Yes" | ""   ("" removes the attribute)
     Gift message  text | ""
   The names are read by the ShipStation sync. Never rename them, never prefix with "_".

   WHY A CUSTOM ELEMENT: the drawer's markup is thrown away and re-parsed on every add and every
   quantity change (cart-drawer.js / cart.js replace .drawer__inner innerHTML). An inline script
   would not re-run; connectedCallback does, for every fresh copy.

   WHY `local`: a re-render can be fetched a few hundred ms before our debounced save lands, so the
   fresh markup may carry the previous server state. Every edit on this page goes through here, so
   the last thing the shopper did on this page is the truth for this page's lifetime; a fresh
   instance adopts it. A reload starts clean from the server-rendered cart.attributes.

   Saves are serialised so a slow early request can never overwrite a later one. Failures are
   swallowed: the hidden inputs in the cart form still carry the state on Check out. */
(function () {
  'use strict';
  if (window.customElements.get('forge-gift')) return;

  var MAX = 250;
  var DEBOUNCE_MS = 400;
  var local = null;
  var chain = Promise.resolve();

  function updateUrl() {
    return (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  }

  function post(state) {
    chain = chain
      .catch(function () {})
      .then(function () {
        return fetch(updateUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { Gift: state.on ? 'Yes' : '', 'Gift message': state.on ? state.msg : '' } }),
          keepalive: true
        });
      })
      .catch(function (e) {
        if (window.console) console.warn('forge-gift: save failed; checkout form still carries it', e);
      });
    return chain;
  }

  class ForgeGift extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('input[type="checkbox"]');
      this.msg = this.querySelector('textarea');
      this.panel = this.querySelector('.forge-gift__panel');
      this.hFlag = this.querySelector('[data-forge-gift-flag]');
      this.hMsg = this.querySelector('[data-forge-gift-msg]');
      if (!this.box || !this.msg || !this.panel) return;

      if (local) this.apply(local);

      this.onBox = this.onBox || this.handleBox.bind(this);
      this.onInput = this.onInput || this.handleInput.bind(this);
      this.onBlur = this.onBlur || this.flush.bind(this);
      this.onPeer = this.onPeer || this.handlePeer.bind(this);
      this.box.addEventListener('change', this.onBox);
      this.msg.addEventListener('input', this.onInput);
      this.msg.addEventListener('blur', this.onBlur);
      document.addEventListener('forge-gift:change', this.onPeer);
    }

    disconnectedCallback() {
      document.removeEventListener('forge-gift:change', this.onPeer);
      this.flush();
    }

    read() {
      return { on: this.box.checked, msg: this.msg.value.slice(0, MAX).trim() };
    }

    apply(state) {
      this.box.checked = state.on;
      if (this.msg.value.trim() !== state.msg) this.msg.value = state.msg;
      this.reflect(state);
    }

    reflect(state) {
      this.panel.hidden = !state.on;
      this.box.setAttribute('aria-expanded', state.on ? 'true' : 'false');
      if (this.hFlag) this.hFlag.value = state.on ? 'Yes' : '';
      if (this.hMsg) this.hMsg.value = state.on ? state.msg : '';
    }

    commit(immediate) {
      var state = this.read();
      local = state;
      this.reflect(state);
      document.dispatchEvent(new CustomEvent('forge-gift:change', { detail: { state: state, source: this } }));
      clearTimeout(this.timer);
      if (immediate) {
        this.pending = false;
        post(state);
      } else {
        this.pending = true;
        var self = this;
        this.timer = setTimeout(function () {
          self.pending = false;
          post(self.read());
        }, DEBOUNCE_MS);
      }
    }

    flush() {
      if (!this.pending) return;
      clearTimeout(this.timer);
      this.pending = false;
      post(local || this.read());
    }

    handleBox() {
      this.commit(true);
      this.retrap();
    }

    /* FORGE a11y (2026-10-20, ACCESSIBILITY_RECHECK R1): the open drawer's focus trap stored its
       first/last controls when it opened. Showing or hiding the message box changes which
       control is last, so recompute the trap, keeping focus on the checkbox. Cart page: no-op. */
    retrap() {
      var drawer = this.closest('#CartDrawer');
      if (!drawer || !drawer.closest('cart-drawer.active') || typeof window.trapFocus !== 'function') return;
      window.trapFocus(drawer, this.box);
    }

    handleInput() {
      this.commit(false);
    }

    /* The cart page also carries the (hidden) drawer copy; keep every instance showing the same state. */
    handlePeer(e) {
      if (!e.detail || e.detail.source === this) return;
      this.apply(e.detail.state);
    }
  }

  window.customElements.define('forge-gift', ForgeGift);
})();
